var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticClass: "fg-gl-news" }, [
    _c("span", [_vm._v("Follow Us On :")]),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "fg-google-news",
        attrs: { href: _vm.extLink },
        on: {
          click: function ($event) {
            return _vm.captureGoogleNewsClick($event)
          },
        },
      },
      [
        _c("img", {
          attrs: {
            src: "/static-assets/images/cssimages/google-news-feature-img.jpg?w=50",
          },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }